// Globals
import { TFunction } from 'react-i18next';
import { ColumnsType } from 'antd/es/table';

// Components
import { StyledBadge } from './ProductVariationsListStyles';
import ProductVariationsActions from './ProductVariationsActions/ProductVariationsActions';

// Models
import { IProductVariation } from '@/models/products.model';

type TGetProductsTableColumns = {
  t: TFunction;
  handleDeleteVariation: (variation: IProductVariation) => void;
  canManage: boolean;
};

export const getProductsTableColumns = ({
  t,
  handleDeleteVariation,
  canManage,
}: TGetProductsTableColumns): ColumnsType<IProductVariation> => {
  return [
    {
      title: t('product_variations_table_col_id'),
      dataIndex: 'id',
      className: 'id-column',
      key: 'id',
      render: (id) => id,
    },
    {
      title: t('product_variations_table_col_sku'),
      dataIndex: 'sku',
      key: 'slu',
      render: (sku) => sku,
    },
    {
      title: t('product_variations_table_col_name'),
      dataIndex: 'name',
      key: 'name',
      render: (name) => name,
    },
    {
      title: t('product_variations_table_col_visibility'),
      dataIndex: 'active',
      key: 'active',
      render: (active) => (
        <StyledBadge $isActive={active}>
          {active ? t('product_variations_table_col_active') : t('product_variations_table_col_inactive')}
        </StyledBadge>
      ),
    },
    ...(canManage
      ? [
          {
            title: t('product_variations_table_col_actions'),
            key: 'actions',
            render: (_: unknown, record: IProductVariation) => (
              <ProductVariationsActions record={record} handleDeleteVariation={handleDeleteVariation} />
            ),
          },
        ]
      : []),
  ];
};
